/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as FeedDefs from "./defs.defs.js";

const $nsid = "app.bsky.feed.getFeedSkeleton";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"feed":/*#__PURE__*/ l.string({"format":"at-uri"}),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"maximum":100,"minimum":1}), 50)),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"feed":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<FeedDefs.SkeletonFeedPost>((() => FeedDefs.skeletonFeedPost) as any), ),"reqId":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":100})),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get a skeleton of a feed provided by a feed generator. Auth is optional, depending on provider requirements, and provides the DID of the requester. Implemented by Feed Generator Service. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["UnknownFeed"]);

export { main };

export const $lxm = $nsid;
